export const host = 'https://learnew.ru/api'
// export const host = 'http://localhost:3000/api'